(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["liquid-glass-product-dock"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[id^="LiquidGlassDock-"]').forEach((section) => {
    const dock = section.querySelector('[data-lgpd-dock]');
    if (!dock || dock.dataset.lgpdReady === 'true') return;
    dock.dataset.lgpdReady = 'true';
    section.querySelectorAll('.lgpd-nav').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.classList.contains('lgpd-nav--next') ? 1 : -1;
        dock.scrollBy({ left: direction * Math.round(dock.clientWidth * 0.68), behavior: 'smooth' });
      });
    });
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    dock.addEventListener('pointerdown', (event) => {
      isDown = true;
      dock.setPointerCapture(event.pointerId);
      startX = event.clientX;
      scrollLeft = dock.scrollLeft;
    });
    dock.addEventListener('pointermove', (event) => {
      if (!isDown) return;
      dock.scrollLeft = scrollLeft - (event.clientX - startX);
    });
    dock.addEventListener('pointerup', () => { isDown = false; });
    dock.addEventListener('pointercancel', () => { isDown = false; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbhnp-cart-drawer-host"]) return;
  try {
    
  (() => {
    const elementName = 'tbhnp-cart-drawer-host';

    if (customElements.get(elementName)) return;

    class TBHNPCartDrawerHost extends HTMLElement {
      connectedCallback() {
        const nativeDrawer = [...document.querySelectorAll('cart-drawer-component')]
          .find((drawer) => !this.contains(drawer));

        if (nativeDrawer) this.remove();
      }
    }

    customElements.define(elementName, TBHNPCartDrawerHost);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbhnp-no-patience-club"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'tbhnp-no-patience-club';
    if (customElements.get(elementName)) return;

    class TBHNPNPC extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.lifecycle = new AbortController();
        this.track = this.querySelector('[data-npc-track]');
        this.cards = [...this.querySelectorAll('[data-npc-card]')];
        this.current = this.querySelector('[data-npc-current]');
        this.closeButton = this.querySelector('[data-npc-close]');
        this.desktopLauncher = this.querySelector('.tbhnp-npc__desktop-launcher');
        this.mobile = window.matchMedia('(max-width: 749px), (orientation: landscape) and (max-height: 520px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.activeIndex = 0;
        this.lastFocus = null;
        this.frame = 0;
        this.drag = null;
        this.wheelDelta = 0;
        this.wheelResetTimer = 0;
        this.wheelUnlockTimer = 0;
        this.bindEvents();
        this.syncFromHash();
        this.update(0, false);
      }

      disconnectedCallback() {
        this.lifecycle?.abort();
        cancelAnimationFrame(this.frame);
        clearTimeout(this.wheelResetTimer);
        clearTimeout(this.wheelUnlockTimer);
        this.initialized = false;
      }

      bindEvents() {
        const { signal } = this.lifecycle;
        this.desktopLauncher?.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(this.desktopLauncher);
        }, { signal });

        document.addEventListener('tbhnp:npc-open', (event) => {
          this.open(event.detail?.trigger);
        }, { signal });

        this.closeButton?.addEventListener('click', () => this.close(), { signal });
        window.addEventListener('hashchange', () => this.syncFromHash(), { signal });
        document.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
        this.track?.addEventListener('scroll', () => this.scheduleMobileIndex(), { passive: true, signal });
        this.track?.addEventListener('wheel', (event) => this.onWheel(event), { passive: false, signal });
        this.track?.addEventListener('pointerdown', (event) => this.onPointerDown(event), { signal });
        this.track?.addEventListener('pointermove', (event) => this.onPointerMove(event), { signal });
        this.track?.addEventListener('pointerup', (event) => this.onPointerUp(event), { signal });
        this.track?.addEventListener('pointercancel', (event) => this.onPointerUp(event), { signal });
      }

      open(trigger) {
        if (!this.cards.length) return;
        this.lastFocus = trigger || document.activeElement;
        const videoIntro = document.querySelector('[data-tbhnp-video-intro]');
        videoIntro?.querySelector('video')?.pause();
        videoIntro?.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.add('tbhnp-video-intro-dismissed');
        document.documentElement.classList.add('tbhnp-npc-open');
        this.setAttribute('aria-hidden', 'false');
        document.querySelector('tbhnp-mobile-global-header')?.setMenuOpen?.(false);
        if (window.location.hash !== '#no-patience-club') history.pushState(null, '', '#no-patience-club');
        requestAnimationFrame(() => {
          this.update(this.activeIndex, false);
          this.closeButton?.focus({ preventScroll: true });
        });
      }

      close() {
        document.documentElement.classList.remove('tbhnp-npc-open');
        this.setAttribute('aria-hidden', 'true');
        if (window.location.hash === '#no-patience-club') history.replaceState(null, '', window.location.pathname + window.location.search);
        this.lastFocus?.focus?.({ preventScroll: true });
      }

      syncFromHash() {
        if (window.location.hash === '#no-patience-club') this.open(document.querySelector('[data-npc-nav-trigger]'));
        else if (document.documentElement.classList.contains('tbhnp-npc-open')) this.close();
      }

      onKeydown(event) {
        if (!document.documentElement.classList.contains('tbhnp-npc-open')) return;
        if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
        if (event.key === 'ArrowRight') { event.preventDefault(); this.go(this.activeIndex + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.activeIndex - 1); }
      }

      onWheel(event) {
        if (this.mobile.matches) return;
        const delta = Math.abs(event.deltaX) > Math.abs(event.deltaY)
          ? event.deltaX
          : event.deltaY;
        if (Math.abs(delta) < 1) return;
        event.preventDefault();
        if (this.wheelLocked) return;

        this.wheelDelta += delta;
        clearTimeout(this.wheelResetTimer);
        this.wheelResetTimer = setTimeout(() => { this.wheelDelta = 0; }, 140);
        if (Math.abs(this.wheelDelta) < 34) return;

        const direction = this.wheelDelta > 0 ? 1 : -1;
        this.wheelDelta = 0;
        this.wheelLocked = true;
        this.go(this.activeIndex + direction);
        clearTimeout(this.wheelUnlockTimer);
        this.wheelUnlockTimer = setTimeout(() => { this.wheelLocked = false; }, 280);
      }

      onPointerDown(event) {
        if (this.mobile.matches || event.button !== 0) return;
        this.drag = { id: event.pointerId, x: event.clientX };
        this.track.setPointerCapture?.(event.pointerId);
      }

      onPointerMove(event) {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const delta = event.clientX - this.drag.x;
        if (Math.abs(delta) > 48) {
          this.go(this.activeIndex + (delta < 0 ? 1 : -1));
          this.drag.x = event.clientX;
        }
      }

      onPointerUp(event) {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        this.track.releasePointerCapture?.(event.pointerId);
        this.drag = null;
      }

      scheduleMobileIndex() {
        if (!this.mobile.matches) return;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const center = this.track.scrollLeft + this.track.clientWidth / 2;
          let best = 0;
          let distance = Infinity;
          this.cards.forEach((card, index) => {
            const cardCenter = card.offsetLeft + card.offsetWidth / 2;
            const nextDistance = Math.abs(center - cardCenter);
            if (nextDistance < distance) { distance = nextDistance; best = index; }
          });
          this.update(best, false);
        });
      }

      go(index) {
        const next = Math.max(0, Math.min(this.cards.length - 1, index));
        this.update(next, true);
      }

      update(index, move) {
        if (!this.cards.length) return;
        this.activeIndex = index;
        this.cards.forEach((card, cardIndex) => {
          const active = cardIndex === index;
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (this.current) this.current.textContent = String(index + 1).padStart(2, '0');
        const card = this.cards[index];
        if (!card) return;
        if (this.mobile.matches) {
          if (move) card.scrollIntoView({ behavior: this.reducedMotion.matches ? 'auto' : 'smooth', inline: 'center', block: 'nearest' });
        } else {
          const viewportCenter = window.innerWidth / 2;
          const cardCenter = card.offsetLeft + card.offsetWidth / 2;
          this.track.style.transform = `translate3d(${viewportCenter - cardCenter}px,0,0)`;
        }
      }
    }

    customElements.define(elementName, TBHNPNPC);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbhnp-pairs-with"] && !Shopify.designMode) return;
  try {
    
  class TbhProductPairs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.successAnimationTimers = new WeakMap();
      this.addEventListener('submit', (event) => this.handleSubmit(event));
      this.addEventListener('change', (event) => this.handleVariantChange(event));
      const selectedIds = new Set();
      const pairTypes = ['garment', 'accessory'];

      for (const pairType of pairTypes) {
        const preferredPool = this.querySelector(`[data-pair-pool="${pairType}-preferred"]`);
        const fallbackPool = this.querySelector(`[data-pair-pool="${pairType}"]`);
        const slot = this.querySelector(`[data-pair-slot="${pairType}"]`);
        const preferredTemplates = Array.from(
          preferredPool?.querySelectorAll('[data-pair-template]') || []
        ).filter((template) => !selectedIds.has(template.dataset.productId));
        const fallbackTemplates = Array.from(
          fallbackPool?.querySelectorAll('[data-pair-template]') || []
        ).filter((template) => !selectedIds.has(template.dataset.productId));
        const templates = (preferredTemplates.length ? preferredTemplates : fallbackTemplates).filter(
          (template) => !selectedIds.has(template.dataset.productId)
        );

        if (!slot || templates.length === 0) {
          this.hidden = true;
          return;
        }

        const selectedTemplate = templates[Math.floor(Math.random() * templates.length)];
        selectedIds.add(selectedTemplate.dataset.productId);
        slot.append(selectedTemplate.content.cloneNode(true));
      }
    }

    handleVariantChange(event) {
      const select = event.target.closest('.tbhnp-pairs-with__variant-select');
      if (!select) return;

      const selectedOption = select.options[select.selectedIndex];
      const card = select.closest('.tbhnp-pairs-with__card');
      const price = card?.querySelector('.tbhnp-pairs-with__price');

      if (price && selectedOption?.dataset.variantPrice) {
        price.textContent = selectedOption.dataset.variantPrice;
      }
    }

    animateSuccess(button) {
      const previousTimer = this.successAnimationTimers.get(button);

      if (previousTimer) {
        window.clearTimeout(previousTimer);
      }

      button.removeAttribute('data-added');
      void button.offsetWidth;
      button.dataset.added = 'true';

      const timer = window.setTimeout(() => {
        button.removeAttribute('data-added');
        this.successAnimationTimers.delete(button);
      }, 1600);

      this.successAnimationTimers.set(button, timer);
    }

    async handleSubmit(event) {
      const form = event.target.closest('[data-pairs-form]');
      if (!form) return;

      event.preventDefault();
      const button = form.querySelector('[data-pairs-add-button]');
      if (!button || button.disabled) return;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      const status = form.querySelector('[data-pairs-form-status]');
      if (status) {
        status.textContent = '';
        status.removeAttribute('data-error');
      }

      try {
        const formData = new FormData(form);
        const cartSectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
          .map((cartItems) => cartItems.dataset.sectionId)
          .filter((sectionId, index, sectionIds) => sectionId && sectionIds.indexOf(sectionId) === index);

        if (cartSectionIds.length > 0) {
          formData.set('sections', cartSectionIds.join(','));
          formData.set('sections_url', window.location.pathname);
        }

        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });

        const responseText = await response.text();
        let responseData;

        try {
          responseData = JSON.parse(responseText);
        } catch {
          throw new Error(form.dataset.errorText || 'Unable to add this item. Please try again.');
        }

        if (!response.ok || responseData.status) {
          throw new Error(responseData.description || responseData.message || 'Unable to add this item to the cart.');
        }

        let cart;

        try {
          const cartResponse = await fetch(window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js', {
            headers: { Accept: 'application/json' },
          });
          cart = cartResponse.ok ? await cartResponse.json() : undefined;
        } catch (cartRefreshError) {
          console.warn('Pairs With cart state refresh failed:', cartRefreshError);
        }

        const cartDrawer = document.querySelector('cart-drawer-component');
        const restoreAutoOpen = cartDrawer?.hasAttribute('auto-open') || false;
        cartDrawer?.removeAttribute('auto-open');

        form.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: form.id,
              data: {
                source: 'product-form-component',
                itemCount: Number(formData.get('quantity')) || 1,
                productId: form.dataset.productId,
                sections: responseData.sections || {},
              },
            },
          })
        );

        if (restoreAutoOpen) {
          cartDrawer?.setAttribute('auto-open', '');
        }

        this.animateSuccess(button);

        if (status) {
          status.textContent = form.dataset.addedText || 'Added to cart';
        }
      } catch (error) {
        if (status) {
          status.setAttribute('data-error', 'true');
          status.textContent =
            error instanceof Error && error.message
              ? error.message
              : form.dataset.errorText || 'Unable to add this item. Please try again.';
        }
        console.error('Pairs With add to cart failed:', error);
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('tbhnp-pairs-with')) {
    customElements.define('tbhnp-pairs-with', TbhProductPairs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbhnp-story-reel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'tbhnp-story-reel';

    if (customElements.get(elementName)) return;

    class TBHNPStoryReel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.lifecycle = new AbortController();
        this.viewport = this.querySelector('[data-story-viewport]');
        this.slides = [...this.querySelectorAll('[data-story-slide]')];
        this.dots = [...this.querySelectorAll('.tbhnp-story-reel__progress-dot')];
        this.soundButton = this.querySelector('[data-story-sound]');
        this.dialogs = [...this.querySelectorAll('[data-story-dialog]')];
        this.activeIndex = 0;
        this.muted = true;
        this.dialogOpen = false;
        document.documentElement.classList.add('tbhnp-story-page');

        this.setViewportHeight(false);
        this.bindEvents();
        this.observeSlides();
        this.activateSlide(0);
      }

      disconnectedCallback() {
        this.lifecycle?.abort();
        this.slideObserver?.disconnect();
        window.cancelAnimationFrame(this.viewportFrame);
        this.initialized = false;

        if (!document.querySelector(elementName)) {
          document.documentElement.classList.remove('tbhnp-story-page');
          document.documentElement.style.removeProperty('--tbhnp-story-viewport-height');
        }
      }

      setViewportHeight(preservePosition = true) {
        const previousHeight = this.viewport?.clientHeight || 0;
        const nearestIndex = previousHeight
          ? Math.round(this.viewport.scrollTop / previousHeight)
          : this.activeIndex;
        const viewportHeight = window.visualViewport?.height || window.innerHeight;
        document.documentElement.style.setProperty(
          '--tbhnp-story-viewport-height',
          `${Math.round(viewportHeight)}px`
        );

        if (!preservePosition || !this.viewport) return;

        window.cancelAnimationFrame(this.viewportFrame);
        this.viewportFrame = window.requestAnimationFrame(() => {
          this.activeIndex = Math.max(0, Math.min(nearestIndex, this.slides.length - 1));
          this.viewport.scrollTo({
            top: this.activeIndex * this.viewport.clientHeight,
            behavior: 'auto'
          });
        });
      }

      observeSlides() {
        if (!this.viewport || !this.slides.length) return;

        this.slideObserver = new IntersectionObserver(
          (entries) => {
            const visible = entries
              .filter((entry) => entry.isIntersecting)
              .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

            if (visible && visible.intersectionRatio >= 0.6) {
              this.activateSlide(this.slides.indexOf(visible.target));
            }
          },
          { root: this.viewport, threshold: [0.6, 0.8] }
        );

        this.slides.forEach((slide) => this.slideObserver.observe(slide));
      }

      activateSlide(nextIndex) {
        if (nextIndex < 0 || nextIndex >= this.slides.length) return;
        this.activeIndex = nextIndex;
        this.dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === nextIndex);
        });

        this.slides.forEach((slide, index) => {
          const video = slide.querySelector('video');
          if (!video) return;

          if (index === nextIndex && !this.dialogOpen && !document.hidden) {
            video.muted = this.muted;
            if (video.readyState === 0) video.load();
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }

      toggleSound() {
        this.muted = !this.muted;
        this.soundButton?.classList.toggle('is-muted', this.muted);
        this.soundButton?.setAttribute('aria-pressed', String(!this.muted));
        this.soundButton?.setAttribute(
          'aria-label',
          this.muted ? this.dataset.soundOnLabel : this.dataset.soundOffLabel
        );
        this.slides.forEach((slide) => {
          const video = slide.querySelector('video');
          if (video) video.muted = this.muted;
        });
      }

      openDialog(dialogId) {
        const dialog = this.querySelector(`#${CSS.escape(dialogId)}`);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        this.dialogOpen = true;
        this.slides[this.activeIndex]?.querySelector('video')?.pause();
        dialog.showModal();
      }

      closeDialog(dialog) {
        if (!dialog?.open) return;
        dialog.close();
      }

      bindEvents() {
        const { signal } = this.lifecycle;
        const resizeHandler = () => this.setViewportHeight(true);

        window.addEventListener('resize', resizeHandler, { signal });
        window.visualViewport?.addEventListener('resize', resizeHandler, { signal });

        this.soundButton?.addEventListener('click', () => this.toggleSound(), { signal });

        this.querySelectorAll('[data-story-dialog-open]').forEach((button) => {
          button.addEventListener(
            'click',
            () => this.openDialog(button.dataset.storyDialogOpen),
            { signal }
          );
        });

        this.dialogs.forEach((dialog) => {
          dialog.querySelector('[data-story-dialog-close]')?.addEventListener(
            'click',
            () => this.closeDialog(dialog),
            { signal }
          );
          dialog.addEventListener(
            'click',
            (event) => {
              if (event.target === dialog) this.closeDialog(dialog);
            },
            { signal }
          );
          dialog.addEventListener(
            'close',
            () => {
              this.dialogOpen = false;
              this.activateSlide(this.activeIndex);
            },
            { signal }
          );
        });

        document.addEventListener(
          'visibilitychange',
          () => {
            if (document.hidden) {
              this.slides.forEach((slide) => slide.querySelector('video')?.pause());
              return;
            }
            this.activateSlide(this.activeIndex);
          },
          { signal }
        );
      }
    }

    customElements.define(elementName, TBHNPStoryReel);
  })();

  } catch(e) { console.error(e); }
})();
})();
